import axios from 'axios'
import {AuthModel, UserModel} from './_models'
import {AUTH_API} from '../../../config/api.config'

// Server should return AuthModel
export function login(username: string, password: string) {
  return axios.post<AuthModel>(AUTH_API.LOGIN, {
    username,
    password,
  }, { suppressToast: true } as any)
}

// Server should return AuthModel
export function register(
  email: string,
  firstname: string,
  lastname: string,
  password: string,
  password_confirmation: string
) {
  // Note: Registration is not implemented in the client app
  return axios.post('/api/register', {
    email,
    fullName: firstname,
    last_name: lastname,
    password,
    password_confirmation,
  })
}

// Server should return object => { result: boolean } (Is Email in DB)
export function requestPassword(email: string) {
  // Note: Password reset is not implemented in the client app
  return axios.post<{result: boolean}>('/api/forgot_password', {
    email,
  })
}

export function getUserByToken(token: string) {
  return axios.post<UserModel>(AUTH_API.USER_INFO, {
    accessToken: token,
  })
}

export function doServerSidelogout() {
  return axios.post<UserModel>(AUTH_API.LOGOUT, {})
}
